import { useQuery } from '@tanstack/react-query';
import { useUsersAdminService } from '../apis/users/useUsersAdminService';
import { TUsersByCategoryResponse } from '../apis/users/users.interfaces';

export const getUsersByCategoryAdminKey = 'admin-get-users-by-category';

export type UseUsersByCategoryAdminParams = {
  category: string;
  page?: number;
  limit?: number;
  search?: string;
};

export const useUsersByCategoryAdminHook = (params: UseUsersByCategoryAdminParams) => {
  const { getUsersByCategory } = useUsersAdminService();
  const { category, page = 1, limit = 10, search } = params;

  return useQuery<TUsersByCategoryResponse>({
    queryKey: [getUsersByCategoryAdminKey, category, page, limit, search],
    queryFn: () => getUsersByCategory({ category, page, limit, search }),
    enabled: !!category,
  });
};
